import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from './base';

const Email = props => (
  <BaseInput
    label="Enter your email"
    type="email"
    autoComplete="off"
    maxLength={50}
    name="email"
    data-cv-test="emailAddress"
    validate={val =>
      string()
        .required('Enter your email')
        .matches(
          /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/g,
          'Enter a valid email address'
        )
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

Email.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string
};

Email.defaultProps = {
  value: '',
  error: ''
};

export default Email;
